import React from "react";
import styles from "./Modal.module.css";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Button from "@material-ui/core/Button";
import { green, orange, red, grey } from "@material-ui/core/colors";

const ModalRepriceInherited = ({
    active,
    setActive,
    modalData,
    setModalResponse,
}) => {
    const rates = modalData.filter((rate) => rate.active);

    function submitHandler(e) {
        e.preventDefault();
        setActive(false);
        let cycle = rates?.length;
        var response = [];
        for (let i = 0; i < cycle; i++) {
            let el = {};
            el.id = e.target.elements.id[i].value;
            el.name = e.target.elements.name[i].value;
            el.oldInherit = e.target.elements.oldInherit[i].value;
            el.operation = e.target.elements.operation[i].value;
            el.unit = e.target.elements.unit[i].value;
            el.rePrice = e.target.elements.rePrice[i].checked;
            response.push(el);
        }
        setModalResponse(response);
    }

    return (
        <div
            className={
                active ? styles.modal + " " + styles.active : styles.modal
            }
        >
            <div
                className={
                    active
                        ? styles.modal__content + " " + styles.active
                        : styles.modal__content
                }
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="MuiTypography-h6">
                    Цены следующих наследованных тарифов будут перезаписаны
                </h2>
                <div className={styles.span__child + " MuiTypography-h6"}>
                    <input
                        className={styles.unset}
                        type="text"
                        readOnly="readOnly"
                        value="ID"
                    />
                    <input
                        className={styles.unset}
                        type="text"
                        readOnly="readOnly"
                        value="Имя"
                    />
                    <input
                        className={styles.unset}
                        type="text"
                        readOnly="readOnly"
                        value="Перезаписать"
                    />
                </div>
                <form className="MuiTypography-h6" onSubmit={submitHandler}>
                    {rates.map((i) => (
                        <div
                            className={
                                "MuiTypography-h6" + " " + styles.div__reprice
                            }
                            key={i.id}
                        >
                            <input
                                className={styles.unset}
                                name="id"
                                type="text"
                                readOnly="readOnly"
                                value={i.id}
                            />
                            <input
                                className={
                                    styles.unset + " " + styles.name__reprice
                                }
                                name="name"
                                type="text"
                                readOnly="readOnly"
                                value={i.name}
                            />
                            <input
                                name="oldInherit"
                                type="hidden"
                                value={i.oldInherit}
                            />
                            <input
                                name="operation"
                                type="hidden"
                                value={i.operation}
                            />
                            <input name="unit" type="hidden" value={i.unit} />
                            <input
                                className={styles.input__reprice__inherited}
                                name="rePrice"
                                type="checkbox"
                                defaultChecked="checked"
                            />
                        </div>
                    ))}
                    <Button
                        variant="contained"
                        endIcon={<ArrowBackIcon />}
                        style={{
                            backgroundColor: orange[500],
                            margin: "30px 5vw 10px",
                        }}
                        onClick={() => setActive(false)}
                        className={styles.button_cancel}
                    >
                        Отмена
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        endIcon={<SaveIcon />}
                        style={{
                            backgroundColor: green[500],
                            margin: "30px 5vw 10px",
                        }}
                        className={styles.button_confirm}
                        type="submit"
                    >
                        Перезаписать
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default ModalRepriceInherited;
